export default "__VITE_ASSET__DBD4jViS__"